import { apiPost, setStoredToken } from "./client";

export interface AuthPlayerSnapshot {
  id: string;
  displayName: string;
  level: number;
  experience: number;
  gold: number;
  currentHp: number;
  currentMana: number;
  currentStamina: number;
  currentLocationId: number;
  currentPositionX: number;
  currentPositionY: number;
}

export interface AuthResponse {
  sessionToken: string;
  player: AuthPlayerSnapshot;
}

export async function authenticate(initData: string): Promise<AuthResponse> {
  const result = await apiPost<AuthResponse>("/api/auth/telegram", { initData });
  setStoredToken(result.sessionToken);
  return result;
}
